import { CmsProtectionDetailsPage } from '../../models/protection-details/cms-protection-details-page.type';
import { mockCmsRegistrationRoot } from '../cms/cms-registration-root.mock';
import { mockCmsProtectionBenefitsAccordion } from './cms-protection-benefits-accordion.mock';
import { mockCmsProtectionDetailsApplianceCarePanelHeader } from './cms-protection-details-appliance-care-panel-header.mock';
import { mockCmsProtectionDetailsExclusions } from './cms-protection-details-exclusions.mock';
import { mockCmsProtectionDetailsHeader } from './cms-protection-details-header.mock';
import { mockCmsProtectionDetailsMultiRegistration } from './cms-protection-details-multi-registration.mock';
import { mockCmsProtectionDetails } from './cms-protection-details.mock';

export const mockCmsProtectionDetailsPage: CmsProtectionDetailsPage = {
  ...mockCmsProtectionBenefitsAccordion,
  ...mockCmsProtectionDetails,
  ...mockCmsProtectionDetailsApplianceCarePanelHeader,
  ...mockCmsProtectionDetailsHeader,
  ...mockCmsProtectionDetailsMultiRegistration,
  ...mockCmsProtectionDetailsExclusions,
  ...mockCmsRegistrationRoot,
  pageTitle: 'pageTitle',
};
